import { connect } from 'react-redux';
import NewsAoVivoMostReadComponent from '../components/NewsAoVivoMostReadComponent';
import { fetchDataNewsMostReadIfNeeded, countNewsView } from '../actions/NewsActions';

const mapStateToProps = (state) => ({
    newsMostRead: state.news.dataNewsMostRead,
});

const mapDispatchToProps = (dispatch) => ({
    fetchDataNewsMostReadIfNeeded: () => dispatch(fetchDataNewsMostReadIfNeeded()),
    countNewsView: (newsViews) => {
        dispatch(countNewsView(newsViews));
    },
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(NewsAoVivoMostReadComponent);
